/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { SolutionTemplate } from "@/components/landing/solution-template";
import { electricalConfig } from "./electrical-config";

export function ElectricalSolutionsPageClient() {
  return <SolutionTemplate config={electricalConfig} />;
}
